import React, { useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../services/pbumku/PbumkuService";

const DisposisiPrimer = ({ idDisposisi }) => {

    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [ketDisposisi, setKetDisposisi] = useState('')

    useEffect(() => {
        const getDisposisi = async () => {
            const response = await pbumkuService.getDisposisiById(idDisposisi)
            // console.log(response)
            setKetDisposisi(response.data.ketDisposisi)
        }
        getDisposisi()
    }, [pbumkuService, idDisposisi])

    return (
        <>
            {ketDisposisi}
        </>
    )
}

export default DisposisiPrimer